import { comparisonPlatforms } from "@/mocks/categories";

export default function CTASection() {
  return (
    <section className="relative py-14 md:py-20 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url(https://readdy.ai/api/search-image?query=Soft%20warm%20minimalist%20flat%20lay%20with%20curated%20accessories%20including%20leather%20wallet%20watch%20and%20silver%20cufflinks%20on%20cream%20surface%2C%20soft%20natural%20daylight%2C%20editorial%20product%20photography%2C%20elegant%20luxurious%20composition%2C%20subtle%20golden%20undertones&width=1800&height=1000&seq=cta-bg-v2-01&orientation=landscape)`,
        }}
      ></div>
      <div className="absolute inset-0 bg-foreground-950/60"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-4">
            Start Exploring The Best{" "}
            <span className="italic text-primary-400">Hipobuy</span> Spreadsheet
          </h2>
          <p className="text-sm md:text-base text-background-50/70 max-w-2xl mx-auto">
            Compare platforms, browse categories, and discover products with the
            most comprehensive spreadsheet shopping guide available.
          </p>
        </div>

        <div className="max-w-3xl mx-auto bg-background-50/95 backdrop-blur-sm rounded-2xl p-6 md:p-8 mb-8">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="border-b border-background-300/60">
                <th className="py-3 px-3 text-xs font-medium text-foreground-500 uppercase tracking-wider">
                  Platform
                </th>
                <th className="py-3 px-3 text-xs font-medium text-foreground-500 uppercase tracking-wider hidden sm:table-cell">
                  Best For
                </th>
                <th className="py-3 px-3 text-xs font-medium text-foreground-500 uppercase tracking-wider">
                  Rating
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonPlatforms.map((platform) => (
                <tr
                  key={platform.name}
                  className={`border-b border-background-200/50 ${
                    platform.highlight ? "bg-primary-50/60" : ""
                  }`}
                >
                  <td className="py-3 px-3 text-sm font-medium text-foreground-900 whitespace-nowrap">
                    {platform.highlight && (
                      <span className="inline-block w-2 h-2 rounded-full bg-primary-500 mr-2"></span>
                    )}
                    {platform.name}
                  </td>
                  <td className="py-3 px-3 text-sm text-foreground-600 hidden sm:table-cell">
                    {platform.bestFor}
                  </td>
                  <td className="py-3 px-3 text-sm text-accent-500 whitespace-nowrap">
                    {platform.rating}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="text-center">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-3 px-8 py-4 text-sm font-semibold text-background-50 bg-foreground-950 hover:bg-foreground-900 rounded-full transition-colors whitespace-nowrap cursor-pointer group"
          >
            <span className="w-7 h-7 flex items-center justify-center rounded-full bg-accent-500 text-background-50">
              <i className="ri-shopping-bag-line text-sm"></i>
            </span>
            Access kaspreadsheet.com
            <i className="ri-arrow-right-up-line text-base ml-1 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
          </a>
        </div>
      </div>
    </section>
  );
}